import React from "react";
import "./Preloader.css";

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="preloader-welcome-container">
        {/* Animated Company Name */}
        <div className="preloader-welcome">
          <span className="eam">
            <span>E</span>
            <span>A</span>
            <span>M</span>
          </span>
          &nbsp;
          <span className="square">
            <span>S</span>
            <span>Q</span>
            <span>U</span>
            <span>A</span>
            <span>R</span>
            <span>E</span>
          </span>
        </div>
      </div>
      {/* Rotating Circular Loader */}
      <div className="loader"></div>
    </div>
  );
};

export default Preloader;
